import React from "react"
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api"
import { StoreDocumentV2 } from "../../../../api/backend/backend-api"

const defaultCenter = {
  lat: 0,
  lng: 0,
}

interface Props {
  store: StoreDocumentV2
}

const StoreMap = ({ store }: Props) => {
  const getCoordinates = () =>
    store?.coordinates
      ? {
          lat: store.coordinates.latitude,
          lng: store.coordinates.longitude,
        }
      : defaultCenter

  return (
    <LoadScript googleMapsApiKey={process.env.GOOGLE_MAPS_API_KEY ?? ""}>
      <GoogleMap
        mapContainerStyle={{
          width: "100%",
          height: "400px",
        }}
        center={getCoordinates()}
        zoom={17}
        options={{
          mapId: "81dc2ddca7d77d00",
          mapTypeControlOptions: {
            mapTypeIds: [],
          },
        }}
      >
        {store && <Marker position={getCoordinates()}>{store.name}</Marker>}
      </GoogleMap>
    </LoadScript>
  )
}

export default StoreMap
